module.exports = __webpack_public_path__ + "img/client-6.3af34b15.webp";